import BForm from "./BForm";

export default class BOAuthAuthorizeForm extends BForm
{
	static selector = () => `.b-oauth-authorize-form`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("click", event => {
			if (event.target.matches(`${this.selector()}__button, ${this.selector()}__button *`)) {
				const button = event.target.closest(`${this.selector()}__button`);
				const form = new this(button.closest(this.selector()));
				form.setAuthorize(button.dataset.authorize);
				form.el.submit();
			}
		});
	}

	setAuthorize(value)
	{
		this.el.querySelector(`[name="authorize"]`).value = value;
	}
}
